'use client';

import { c as _c } from "react/compiler-runtime";
import { CompanyFilterComponentProps } from '@repo/table/filters';
import { CompanyCommand } from './company-command';
type CompanyFilterProps = CompanyFilterComponentProps<null | {
  label: string;
  value: string;
}>;
export function CompanyFilter(t0) {
  const $ = _c(5);
  const {
    autoFocus,
    onChange
  } = t0;
  let t1;
  if ($[0] !== onChange) {
    t1 = company => {
      onChange({
        label: company.title,
        value: company.id.toString()
      });
    };
    $[0] = onChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleOnSelect = t1;
  let t2;
  if ($[2] !== autoFocus || $[3] !== handleOnSelect) {
    t2 = <CompanyCommand autoFocus={autoFocus} className="md:min-w-80" onSelect={handleOnSelect} data-sentry-element="CompanyCommand" data-sentry-component="CompanyFilter" data-sentry-source-file="company-filter.tsx" />;
    $[2] = autoFocus;
    $[3] = handleOnSelect;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}